// src/components/PrivateRoute.jsx

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { currentUser, userData, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading-state">Authenticating...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  if (!userData) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  if (!allowedRoles.includes(userData.role)) {
    // If not allowed, send them to their default valid page
    if (userData.role === 'superadmin') {
        return <Navigate to="/dashboard/manage" replace />;
    }
    if (userData.role === 'admin' || userData.role === 'employee') {
        return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;